module.exports = __webpack_public_path__ + "img/swiper-right.59b22b57.png";